import React, { useEffect, useMemo } from 'react';
import Title from '../../shared/Title/Title';
import { getTranslation } from '../../../utils/translation';
import { getSportTypes, resetSportsList } from '../../../store/actions/sportTypes';
import { getFavoriteEvents, getFavoriteLeagues } from '../../../store/actions/favorites';
import { useDispatch, useSelector } from 'react-redux';
import styles from './SportsNav.module.scss';
import Placeholder from '../../shared/Sports/Type/Placeholder/Placeholder';
import { SPORTS_TYPES_DIRECTION } from '../../../constants/defaultValues';
import NavItems from './NavItems';
import { useLocation } from 'react-router-dom';

const PreMatchSports = () => {
    const dispatch = useDispatch();

    const { fetching } = useSelector(state => state.sportTypes);
    const { eventType } = useSelector(state => state.sportEvents);

    const location = useLocation();

    const isEsportPage = useMemo(() => {
        return location.pathname.includes("e-sports") || location.pathname.includes("e-live");
    }, [location.pathname]);

    useEffect(() => {
        if (isEsportPage !== null){
            dispatch(getSportTypes({ isLive: false, eventType: eventType.value, eSport: isEsportPage }));
        }
        dispatch(getFavoriteEvents());
        dispatch(getFavoriteLeagues());

        return () => {
            dispatch(resetSportsList());
        };
    }, [eventType, isEsportPage]);

    return (
        <>
            <Title title={getTranslation('title.sports')} />
            <nav className={styles.preMatchNav}>
                <ul className={styles.menu}>
                    {fetching ? (
                        <Placeholder count={20} direction={SPORTS_TYPES_DIRECTION.vertical} />
                    ) : (
                        <NavItems />
                    )}
                </ul>
            </nav>
        </>
    );
};

export default PreMatchSports;
